<template>
  <p id="readMore">
    <span class="display RemoveHTMLStyle" v-html="text_display"></span>
    <span class="a nowrap RemoveHTMLStyle" @click="readMore" v-if="this.text_full.length >=this.slice" v-html="view"></span>
  </p>
</template>

<script>
export default {
  name: 'readMore',
  props: {
    text_display: String,
    view: String,
    view_more: String,
    view_less: String,
    text_less: String,
    text_full: String,
    slice: Number
  },
  methods: {
    readMore: function () {
      if (this.text_display === this.text_full) {
        this.text_display = this.text_less
        this.view = this.view_more
      } else {
        this.text_display = this.text_full
        this.view = this.view_less
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/General/ReadMore.vue